<template xmlns="http://www.w3.org/1999/html">
  <div class="container">
    <el-card class="my-card" :body-style="{ padding: '20px' }">
      <div class="my-page">
        <img :src="imageUrl" alt="Paycools" class="card-image"/><br>
        <div class="text-wrapper">
          <p class="description">Request permission to:</p>
          <p class="description">• Auto-dedit from your eWallet upon every transaction you make.</p>
          <p class="description">• It is only used as a test environment simulation.
            Click the button below to get callback notification:</p>
          <br>
        </div>
        <el-button
          style="background-color: #3855F1; color: white !important; padding: 10px 70px; text-align: center; text-decoration: none; display: inline-block; font-size: 16px; margin-left: 20px; cursor: pointer; border: none; border-radius: 8px; font-weight: 700;"
          @click="handleClick">
          Authorize Now
        </el-button>
        <br>
      </div>
    </el-card>
  </div>
</template>

<script>
import { simulatePayToken } from "@/api/system/system"

export default {
  data() {
    return {
      imageUrl: '/logo_paycools.png',
    }
  },
  created() {

  },
  methods: {
    handleClick() {
      const params = {
        app_id: this.$route.query.appId,
        agreement_id: this.$route.query.agreementId
      }
      simulatePayToken(params).then(res => {
        if (res.code === 10000) {
          this.$message.success('Success')
        }
      })
    }
  }
}
</script>

<style scoped>
.container {
  background-color: #F7F7F7;
  padding: 60px;
  min-height: 100vh;
}

.my-card {
  background-color: white;
  max-width: 1000px;
  margin: 0 auto;
}

.my-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.card-image {
  max-width: 8%;
  height: auto;
}

.text-wrapper {
  text-align: left;
  width: 100%;
  max-width: 480px;
}

.description {
  margin: 15px 0;
  font-size: 15px;
  color: #333;
  position: relative;
}

</style>
